import React from 'react';

export default function DummySentryTestPage(props) {
  const x = undefined;

  return (
    <div>
      {x.map((i, key) => {
        return i;
      })}
    </div>
  );
}
